import { render, staticRenderFns } from "./AccessPolicyPreview.vue?vue&type=template&id=df66226a&"
import script from "./AccessPolicyPreview.vue?vue&type=script&lang=ts&"
export * from "./AccessPolicyPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports